<template>
  <component :is="formComponent" />
</template>

<script>
/**
 * Форма настроек: подключает кастомный шаблон из templates/ по section.key
 * (например section.key = "bookings" → templates/Bookings.vue),
 * иначе использует дефолтный Form.vue.
 */
const templatesContext = require.context('./templates', false, /\.vue$/)
const templateKeys = templatesContext.keys()

function toPascalCase(str) {
  if (!str) return ''
  return str
    .split(/[_-]/)
    .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join('')
}

function hasTemplate(sectionKey) {
  const name = toPascalCase(sectionKey)
  return templateKeys.some(key => key === `./${name}.vue` || key.endsWith(`/${name}.vue`))
}

export default {
  name: 'SettingsFormRouter',

  computed: {
    formComponent() {
      const sectionKey = this.$route.params.section
      if (!sectionKey) {
        return () => import('./Form.vue')
      }
      if (hasTemplate(sectionKey)) {
        const name = toPascalCase(sectionKey)
        const module = templatesContext(`./${name}.vue`)
        const component = module.default || module
        return () => Promise.resolve(component)
      }
      return () => import('./Form.vue')
    },
  },
}
</script>
